<template>
	<div class="progress-tracker">
		<div
			v-for="(num, index) in numPages"
			:key="num"
			class="circle"
			:class="{ selected: index == currentPage, active: index <= currentPage }"
		></div>
	</div>
</template>
<script>
export default {
	props: {
		numPages: {
			type: Number,
			default: 0
		},
		currentPage: {
			type: Number,
			default: 0
		}
	}
};
</script>
<style lang="scss" scoped>
.progress-tracker {
	display: flex;
	align-items: center;

	.circle {
		height: 8px;
		width: 8px;
		border-radius: 8px;
		background-color: $inactive-page-color;
		margin-right: 12px;

		&.selected {
			height: 16px;
			width: 16px;
			border-radius: 16px;
			background-color: $selected-page-color;
		}

		&.active {
			&:not(.selected) {
				background-color: $active-page-color;
			}
		}
	}
}
</style>
